import React, { useState, useEffect } from "react";
import styles from "./NotificationModal.module.css";

interface NotificationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const NotificationModal: React.FC<NotificationModalProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // Only close if clicking the overlay itself, not the modal content
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        <div className={styles.content}>
          <div className={styles.pill}>New</div>

          <h2 className={styles.title}>Introducing Noah (BETA)</h2>

          <div className={styles.bulletPoints}>
            <div className={styles.bulletItem}>
              <div className={styles.bulletCircle}></div>
              <p className={styles.bulletText}>
                Turn your ideas into 3D models with text-to-CAD and work with
                fully editable geometry
              </p>
            </div>
            <div className={styles.bulletItem}>
              <div className={styles.bulletCircle}></div>
              <p className={styles.bulletText}>
                Export to .STL for 3D printing or .STEP to open your models in
                other CAD platforms
              </p>
            </div>
            <div className={styles.bulletItem}>
              <div className={styles.bulletCircle}></div>
              <p className={styles.bulletText}>
                Make your models public to share with others, or keep them
                private and viewable only by you
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;
